
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../../actions/AppActions';
import { connect } from 'react-redux';

// Registros
import moment from 'moment';
import { URL } from '../../../variables';
import ReactPaginate from 'react-paginate';
import { MdDelete, MdModeEdit, MdSearch, MdVisibility } from 'react-icons/md';
import { maskNumberBr, maskPrice } from '../../../Auxiliar/Masks';
import { BsFillCircleFill, BsFilter, BsFilterCircle, BsInfoCircleFill } from 'react-icons/bs';
import { Checkbox, IconButton, Tooltip } from '@mui/material';
import DadosFiscaisModal from '../../Modais/DadosFiscaisModal';


class DestinacaoInternaFiscais extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            Destinacao: {},
            dados_contato: [],
            page: 1,
            total_pages: 1,
            msgErro: '',
            show_erro: false,
            registro_to_delete: '',
            search: '',
            checkedItems: [],
            ChaveNota: '',
            NumeroNota: '',
            SerieNota: '',
        };
    }

    componentDidMount() {
        this.get_Destinacao_fiscais(this.state.page);
        this.props.setSearch(false)
    }

    componentDidUpdate() {
        if (this.props.search) {
            this.props.setSearch(false)
            this.get_Destinacao_fiscais(this.state.page);
        }
    }


    handleCheckbox = (item) => {
        const { checkedItems } = this.state;
        const isChecked = checkedItems.find((checkedItem) => checkedItem.id === item.id);

        if (isChecked) {
            // Remove o item da lista
            const updatedItems = checkedItems.filter((checkedItem) => checkedItem.id !== item.id);
            this.setState({ checkedItems: updatedItems });
        } else {
            // Adiciona o item à lista
            this.setState({ checkedItems: [...checkedItems, item] });
        }
    };

    handleList = () => {
        const updatedDestinacoes = this.state.Destinacao.filter((item) => !this.state.checkedItems.some((selected) => selected.id === item.id));
        this.setState({ Destinacao: updatedDestinacoes, checkedItems: [] });
    };

    get_Destinacao_fiscais(page, search = '', busca = false) {
        if (busca == true) {
            if (this.state.loading_search == false) {
                this.setState({ loading_search: true });
            }
        }
        else if (this.state.loading_screen === false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/get_destinacoes_internas_fiscais?page=${page}&search=${search}&dateOf=${this.props.dateOf}&dateFor=${this.props.dateFor}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    this.props.logout();
                    return;
                }
                else {
                    this.setState({
                        Destinacao: resp.destinacao,
                        loading_screen: false,
                        page: resp.pagination.current_page,
                        total_pages: resp.pagination.last_page,
                        loading_search: false,
                        redirect: false
                    });
                }
            } catch (err) {
                console.log(err)
                this.setState({ redirect: true });
            }

        })
            .catch((err) => {
                console.log(err)
                this.setState({ redirect: true });
            });
    }



    render() {
        return (
            <>
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                {this.state.loading_screen == false && <div>
                    <div className="row mb-2">
                        <div className="col-12 col-md-6">
                            {/* <form className="app-search mt-1" style={{ width: '100%' }} onSubmit={(e) => {
                                this.setState({ page: 1 });
                                this.get_Destinacao_fiscais(1, this.state.search, true)
                                e.preventDefault();
                            }}>
                                <div className="form-group mb-0" style={{ width: '100%', position: 'relative' }}>
                                    <input value={this.state.search} name="search" placeholder="Pesquisar pelo Destino..." className="form-control" style={{ width: '100%', paddingRight: 40, borderRadius: 100 }} onChange={(e) => {
                                        clearTimeout(this.pesquisarTimeout);
                                        let search = e.target.value;
                                        this.setState({ page: 1, search: search });
                                        this.pesquisarTimeout = setTimeout(() => {
                                            this.get_Destinacao_fiscais(1, search, true)
                                        }, 500);
                                    }} />
                                    <div style={{ width: 40, position: "absolute", right: 0, top: 0, bottom: 0, display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                                        <MdSearch />

                                    </div>

                                </div>
                            </form> */}
                        </div>
                        <div className="col-12 col-md-6 d-flex justify-content-end">
                            <DadosFiscaisModal destinacoes={this.state.checkedItems} token={this.props.token} updateDestinacoes={this.handleList}/>
                            <Tooltip title={<span style={{fontSize:'0.85rem'}}>"Selecione várias destinações para gerar uma nota fiscal única que englobe todas elas"</span>}>
                                <a className='text-secondary' style={{ padding: 0, margin: 0 }}>
                                    <BsInfoCircleFill size={24}/>
                                </a>
                            </Tooltip>
                        </div>
                    </div>
                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped table-hover" style={{ textAlign: 'center' }}>
                                <thead>
                                    <tr>
                                        <th>Destino</th>
                                        <th>Peso Atendido</th>
                                        <th>Saldo (R$)</th>
                                        <th>Data de Início</th>
                                        <th>Status</th>
                                        <th data-priority="3">Ações</th>
                                    </tr>
                                </thead>
                                {/* dados da lista ----------------------------------- */}
                                <tbody>
                                    {this.state.loading_search == false && this.state.Destinacao.map((item, id) => (
                                        <tr key={item.id}>

                                            <td>{item.destino_fantasia}</td>
                                            <td>{maskNumberBr(item.peso_total + '')} Kg</td>
                                            <td>{maskPrice(item.saldo)}</td>
                                            <td>{item.data_criacao.replace(/(\d*)-(\d*)-(\d*).*/, '$3/$2/$1')}</td>
                                            <td>{item.situacao}</td>

                                            <td className='d-flex align-items-center justify-content-center'>
                                                <Tooltip className='m-1' title={this.state.checkedItems.indexOf(item.id) !== -1 ? "Remover" : "Selecionar"}>
                                                    <Checkbox
                                                        checked={this.state.checkedItems.find((checkedItem) => checkedItem.id === item.id) !== undefined}
                                                        onChange={() => this.handleCheckbox(item)}
                                                    />
                                                </Tooltip>
                                                {item.finalizada && <Tooltip className='m-1' title="Ver">
                                                    <Link to={'/destinacao_interna_finalizada/view/' + item.id}><span className="btn btn-warning btn-outline btn-circle me-1 mb-1"
                                                    ><MdVisibility style={{ color: 'white' }} /></span></Link>
                                                </Tooltip>}
                                                {!item.finalizada && <Tooltip className='m-1' title="Ver">
                                                    <Link to={'/destinacao_interna_pendente/view/' + item.destinacao_interna_id}><span className="btn btn-warning btn-outline btn-circle me-1 mb-1"
                                                    ><MdVisibility style={{ color: 'white' }} /></span></Link>
                                                </Tooltip>}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>

                        </div>
                    </div>
                    {this.state.Destinacao.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhuma Destinação com pendências fiscais</p>

                        </div>
                    </div>}
                    <div className="row">
                        <div className="col-12 d-flex justify-content-end">
                            <ReactPaginate
                                previousLabel={'Anterior'}
                                nextLabel={'Próxima'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.total_pages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={2}
                                onPageChange={this.handlePageClick.bind(this)}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}
                                initialPage={this.state.page - 1}
                            />
                        </div>
                    </div>



                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                </div>}

                {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    <div className="spinner-border text-primary" role="status"  >
                    </div>
                </div></div>}

            </>
        );
    }
    handlePageClick(page) {
        if (page.selected + 1 != this.state.page) {
            this.setState({ page: page + 1 });
            this.get_Destinacao_fiscais(page.selected + 1);
        }
    }
}
const mapsStateToProps = (state) => (
    {
        user: state.AppReducer.user,
        token: state.AppReducer.token,
    }
);

export default connect(mapsStateToProps, { logout })(DestinacaoInternaFiscais);
